<template>
    <div class="row">
        <page-title :title="$t('budgetTemplate.title')" :showTitle="false"></page-title>
        <div class="card mx-auto mt-2 px-0">
            <div class="card-header bg-primary text-white">
                <div class="card-title h5 m-0">
                    {{ $t('budgetTemplate.title') }}
                </div>
            </div>
            <div class="card-header">
                <button type="button" class="btn btn-primary btn-lg btn-primary"
                        v-if="showNewButton || claims.nijEmployee.create"
                        @click="goToCreate">
                    {{$t('buttons.create.btnText')}}
                </button>
            </div>
            <div class="card-body">
                <kendo-datasource ref="datasource1"
                                  :transport="transportSettings"
                                  :schema-model-id="'id'"
                                  :schema-model-fields="schemaModelFields"
                                  :schema-total="'count'"
                                  :schema-data="'items'"
                                  :page-size='defaultGridRows'
                                  :server-paging="true"
                                  :server-sorting="true"
                                  :server-filtering="true"
                                  :error="dataSourceError">
                </kendo-datasource>
                <kendo-grid ref="grid"
                            :height="600"
                            :data-source-ref="'datasource1'"
                            :editable="gridOptions.editable"
                            :filterable="gridOptions.filterable"
                            :pageable="gridOptions.pageable"
                            :reorderable="gridOptions.reorderable"
                            :resizable="gridOptions.resizable"
                            :groupable="gridOptions.groupable"
                            :allow-copy="gridOptions.allowCopy"
                            :column-menu="gridOptions.columnMenu"
                            :sortable-mode="gridOptions.sortable.mode"
                            :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                            :sortable-show-indexes="gridOptions.sortable.showIndexes"
                            :selectable="gridOptions.selectable"
                            :scrollable="gridOptions.scrollable"
                            :dataBound="dataBound">
                    <kendo-grid-column :field="'id'"
                                       :title="$t('activity.id')">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'name'"
                                       :title="$t('budget.name')">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'nameEn'"
                                       :title="$t('budget.nameEn')">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'deactivated'"
                                       :template="booleanCellTemplate"
                                       :title="$t('buttons.deactivate.status')">
                    </kendo-grid-column>
                    <kendo-grid-column :template="btnsTemplate"
                                       field="btnsColumn"
                                       :title="$t('actions')"
                                       v-if="showBtns">
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import store from '../../store/store';
    import GridUserSettings from "../../components/grid/UserSettings";
    import BtnsTemplate from "../../components/grid/StandardBtnsTemplate";
    import PageTitle from '../../components/common/PageTitle';
    import DatetimeCellDisplayTemplate from "../../components/grid/DatetimeCellDisplayTemplate";
    import { mapGetters } from 'vuex';

    export default {
        props: {
            showHideButton: {
                default: false,
                type: Boolean
            },
            showPinButton: {
                default: true,
                type: Boolean
            },
            showNewButton: {
                default: true,
                type: Boolean
            },
            showExportTemplateButton: {
                default: true,
                type: Boolean
            },
            showImportFromExcelButton: {
                default: true,
                type: Boolean
            },
            showResizeIcon: {
                default: false,
                type: Boolean
            },
            size: {
                default: 6,
                type: Number
            },
            showBtns: {
                default: true,
                type: Boolean
            },
            showSettingsBtn: {
                default: true,
                type: Boolean
            }
        },
        components: {
            PageTitle,
            'grid-user-settings': GridUserSettings,
        },
        data() {
            return {
                componentName: "annualcatalogproject",
                titleKey: 'activity.title',
                defaultGridRows: this.$store.getters.defaultGridRows,
                settingsTooltipText: this.$t('buttons.settings.tooltipText'),
                schemaModelFields: {
                    id: { name: 'id', type: 'number', editable: false, nullable: true, visible: true, titleKey: 'activity.id' },
                    name: { name: 'name', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'budget.name' },
                    nameEn: { name: 'nameEn', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'budget.nameEn' },
                    deactivated: { name: 'deactivated', type: 'boolean', editable: false, nullable: false, visible: true, titleKey: 'buttons.deactivate.status' }
                },
                rawHtml: "",
                transportSettings: {
                    read: {
                        url: `${store.getters.baseUrl}/api/BudgetTemplate/list`,
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                showUserSettingsForm: false,
                newDate: ''
            }
        },
        methods: {
            goToEdit(args) {
                this.$router.push('/registers/budgetTemplate/edit/' + args.id);
            },
            goToCreate(args) {
                this.$router.push('/registers/budgetTemplate/create');
            },
            activate(args) {
                const objToSend = {
                    id: args.id,
                    deactivate: false
                };
                this.$http.post('/api/BudgetTemplate/SetDeactivated', objToSend).then(result => {
                    const grid = this.$refs.grid.kendoWidget();
                    if (grid) {
                        grid.dataSource.read();
                    }

                    this.$vs.notify({
                        title: this.$t('budget.activationSuccess'),
                        text: this.$t('budget.activationSuccess'),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    });
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('notifications.error'),
                        text: this.$t('budget.activationUnSuccess'),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    });
                });
            },
            deactivate(args) {
                const objToSend = {
                    id: args.id,
                    deactivate: true
                };
                this.$http.post('/api/BudgetTemplate/SetDeactivated', objToSend).then(result => {
                    const grid = this.$refs.grid.kendoWidget();
                    if (grid) {
                        grid.dataSource.read();
                    }

                    this.$vs.notify({
                        title: this.$t('budget.deactivationSuccess'),
                        text: this.$t('budget.deactivationSuccess'),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    });
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('notifications.error'),
                        text: this.$t('budget.deactivationUnSuccess'),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration,
                    });
                });
            },
            deleteClicked(args) {
                this.$http.delete(`/api/BudgetTemplate/${args.id}`)
                    .then(() => {
                        const grid = this.$refs.grid.kendoWidget();
                        if (grid) {
                            grid.dataSource.read();
                        }

                        this.$vs.notify({
                            title: this.$t('notifications.success'),
                            text: this.$t('notifications.successfulSavedData'),
                            position: 'top-center',
                            color: 'success'
                        });
                        this.$router.go();
                    }).catch(error => {
                        this.$vs.notify({
                            title: this.$t('notifications.error'),
                            text: this.$t('notifications.errorDataNotSaved'),
                            position: 'top-center',
                            color: 'danger'
                        });
                    }
                );
            },
            booleanCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.deactivated ? 'badge-success' : 'badge-secondary') + '">' + kendo.htmlEncode(dataItem.deactivated ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            dataBound(e) {
                this.loadColumnsVisibilitySettings();
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    this.saveState();
                    return kendo.stringify(options);
                }
            },
            saveState: function () {
                let grid = this.$refs.grid.kendoWidget();

                localStorage["audit-grid-options"] = kendo.stringify(grid.getOptions());
            },
            loadState: function () {
                let options = localStorage["kendo-grid-options"];
                let grid = this.$refs.grid.kendoWidget();

                if (options) {
                    grid.setOptions(JSON.parse(options));
                }
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            toolbarTemplate: function () {
                let templateHtml =
                    '<span>' +
                    '<a class="k-pager-refresh k-link k-button" title="Refresh"><span class="k-icon k-i-reload"></span></a>' +
                    '</span>';

                return kendo.template(templateHtml);
            },
            btnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        parentComponent: this.$refs.grid,
                        btns: [
                            {
                                name: "edit",
                                text: "",
                                tooltip: this.$t('buttons.edit.tooltipText'),
                                class: 'btn btn-success',
                                icon: "fas fa-edit",
                                show: true,
                                clickHandler: this.goToEdit
                            },
                            {
                                name: "delete",
                                text: "",
                                tooltip: this.$t('buttons.delete.tooltipText'),
                                class: 'btn btn-danger',
                                icon: "fas fa-trash",
                                show: true,
                                clickHandler: this.deleteClicked
                            },
                            {
                                name: "activate",
                                text: "",
                                tooltip: this.$t('buttons.activate.tooltipText'),
                                class: 'btn btn-danger',
                                icon: "fas fa-eye",
                                show: e.deactivated,
                                clickHandler: this.activate
                            },
                            {
                                name: "deactivate",
                                text: "",
                                tooltip: this.$t('buttons.deactivate.tooltipText'),
                                class: 'btn btn-danger',
                                icon: "fas fa-eye-slash",
                                show: !e.deactivated,
                                clickHandler: this.deactivate
                            }
                        ]
                    }
                };
            },
            changeGridSettings() {
                this.showUserSettingsForm = !this.showUserSettingsForm;
            },
            datetimeDisplayTemplate: function (e) {
                return this.newDate = {
                    template: Vue.component(DatetimeCellDisplayTemplate.name, DatetimeCellDisplayTemplate),
                    templateArgs: {
                        dateValue: e.date,
                        showShortDate: false
                    },
                };
            },
            gridSettingsChanged(componentName, name, value) {
                this.setColumnVisibilitySettings();
            },
            loadColumnsVisibilitySettings() {
                return this.$http.get('/api/personalization/' + this.componentName + '/getColumnVisibility'
                ).then((response) => {
                    if (response.data.settings === null) {
                        return;
                    }

                    let settings = [];
                    for (var i = 0; i < response.data.settings.length; i++) {
                        settings.push(response.data.settings[i].name)
                    }
                    for (const key in this.schemaModelFields) {
                        if (this.schemaModelFields.hasOwnProperty(key)) {
                            this.schemaModelFields[key].visible = settings.includes(key);
                        }
                    }

                    this.setColumnVisibilitySettings();
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                })
            },
            setColumnVisibilitySettings() {
                var grid = this.$refs.grid.kendoWidget();
                var columns = grid.columns;

                // restore columns visibility state using the stored values
                for (var i = 0; i < columns.length; i++) {
                    var column = columns[i];
                    if (!column.field
                        || !this.schemaModelFields.hasOwnProperty(column.field)
                        || !this.schemaModelFields[column.field].hasOwnProperty('visible')) {
                        continue;
                    }

                    if (this.schemaModelFields[column.field].visible) {
                        grid.showColumn(column);
                    }
                    else {
                        grid.hideColumn(column);
                    }
                }
            }
        },
        mounted: function () {
            const container = $(this.$el);
            container.find('[data-toggle="tooltip"]').tooltip({ container });
        },
        computed: {
            ...mapGetters(['gridOptions', 'claims']),
            token: function () {
                return store.getters.authToken;
            },
        }
    }
</script>

<style scoped>
    .btn {
        margin-right: 10px;
        margin-left: 5px;
    }

    .checkbox {
        margin-right: 5px;
    }

    .selectFile {
        display: none;
    }

    .inlineForm {
        display: inline;
    }
</style>
